<template>
  <svg :class="`icon-${size}`" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 10.5H16.1295L10.5 20.1505V13V12.5H10H7.5V2.5H16.191L12.5528 9.77639L12.191 10.5H13Z" stroke="currentColor" />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  size: { type: Number, default: 20 }
})
</script>
